import React from 'react';
import ReactDOM from 'react-dom';
import { createStore, applyMiddleware, compose } from 'redux';
import { Provider } from 'react-redux';
import multi from 'redux-multi';
import { createLogger } from 'redux-logger';
import 'airbnb-js-shims';

import curator from './reducers';

import App from './App';
import * as serviceWorker from './serviceWorker';

import './index.scss';

const loggerMiddleware = createLogger();
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(curator, {}, composeEnhancers(applyMiddleware(
  multi,
  loggerMiddleware
)));

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root')
);

console.log('version 2.5');

serviceWorker.unregister();


// if (window.location.hostname === 'localhost') {
//   (function() {

//     const gcd = (a, b) => {
//       let temp, m;
//       if (b > a) {
//         temp = a;
//         a = b;
//         b = temp
//       }
//       while (b !== 0) {
//         m = a % b;
//         a = b;
//         b = m;
//       }
//       return a;
//     }
    
//     const ratio = (x, y) => {
//       let c = gcd(x, y);
//       return "" + (x / c) + ":" + (y / c)
//     }

//     function dynamicResizer() {
//       var docWidth = window.innerWidth,
//         docHeight = window.innerHeight;
//       const r = ratio(docWidth, docHeight)
//       spanDimensions.innerHTML = docWidth + " x " + docHeight + '<br>' + r;
//     }

//     // Create the ViewPort detector
//     var viewDetector = document.createElement('div');
//     // const body = document.getElementsByTagName('body');
//     document.getElementsByTagName('body')[0].appendChild(viewDetector).id = 'viewport-detector';

//     // Load and Resize events
//     window.onresize = dynamicResizer;
//     window.onload = dynamicResizer;

//     // Create <span class="dimensions"> and append
//     var spanDimensions = document.createElement('span');
//     spanDimensions.className = 'dimensions';
//     document.getElementById('viewport-detector').appendChild(spanDimensions);

//     // Create <span class="retina"> and append
//     var spanRetina = document.createElement('span');
//     spanRetina.className = 'retina';
//     document.getElementById('viewport-detector').appendChild(spanRetina);

//     // Create <span class="pixel-ratio"> and append
//     var spanPixels = document.createElement('span');
//     spanPixels.className = 'pixel-ratio';
//     document.getElementById('viewport-detector').appendChild(spanPixels);
//     spanPixels.innerHTML = 'Pixel Ratio: ' + window.devicePixelRatio;

//     // Retina detect
//     if(window.devicePixelRatio >= 2) {
//       spanRetina.innerHTML = 'Retina Device';
//     } else {
//       spanRetina.innerHTML = 'No Retina Device';
//     }
//   })();
// }